import {Route, Routes} from "react-router-dom";
import ReactGA from "react-ga4";
import {TemplateProvider} from "./contexts/templateContext.tsx";
import {Home} from "./pages/Home.tsx";
import {Quiz} from "./pages/Quiz.tsx";
import {Result} from "./pages/Result.tsx";
import {RootLayout} from "./components/layout/RootLayout.tsx";
import {QuizLayout} from "./components/layout/QuizLayout.tsx";
import {ResultLayout} from "./components/layout/ResultLayout.tsx";
import {AuthProvider} from "@/contexts/authContext.tsx";

export const App = () => {
    if (import.meta.env.VITE_ENV === 'dev') {
        ReactGA.initialize("G-7HYENG39WT", {
            gaOptions: {
                send_page_view: false,
                debug_mode: true,
            },
            gtagOptions: {
                debug_mode: true,
            }
        });
    }
    if (import.meta.env.VITE_ENV === 'production') {
        ReactGA.initialize(import.meta.env.VITE_GTAG ??  "G-XTSLTNLBLY", {
            gaOptions: {
                send_page_view: false,
            }
        });
    }

    return (
        <TemplateProvider>
            <AuthProvider>
                <Routes>
                    <Route element={<RootLayout/>}>
                        <Route index element={<Home/>}/>
                    </Route>

                    <Route element={<QuizLayout/>}>
                        <Route path="/quiz" element={<Quiz/>}/>
                    </Route>

                    <Route element={<ResultLayout/>}>
                        <Route path="/result/:points" element={<Result/>}/>
                    </Route>
                </Routes>
            </AuthProvider>
        </TemplateProvider>
    );
};
